import { render, staticRenderFns } from "./index.vue?vue&type=template&id=038e7047&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=038e7047&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e7047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\repository\\india-admin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038e7047')) {
      api.createRecord('038e7047', component.options)
    } else {
      api.reload('038e7047', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=038e7047&scoped=true", function () {
      api.rerender('038e7047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/index.vue"
export default component.exports